import axios from "axios";
import { toast } from "react-toastify";
import { commonMessage } from "constants/commonMessage";

// https://axios-http.com/
// const axiosInstance = axios.create({
//     baseURL: process.env.REACT_APP_API_BASE_URL,
//     timeout: 1000,
//     headers: {
//         'Content-Type': 'application/json'
//     }
// });

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

axios.interceptors.request.use((request) => {
    const token = localStorage.getItem(process.env.CURRENT_USER_TOKEN); // Change Later
    request.headers.Authorization = `Bearer ${token}`;        
    return request;
}, (error) => {
    toast.error(commonMessage.somethingWrong());
    console.log(error);
});

axios.interceptors.response.use((response) => {
    return response.data;
}, (error) => {
    if (error.response && error.response.status === 401) {
        toast.warn("Unauthorized");
    } else {
        toast.error(commonMessage.somethingWrong());
    }
});

const apiService = {
    get: (apiEndpoint, params) => axios.get(apiEndpoint, { params }),
    post: (apiEndpoint, data) => axios.post(apiEndpoint, data),
    put: (apiEndpoint, data) => axios.put(apiEndpoint, data),
    patch: (apiEndpoint, data) => axios.patch(apiEndpoint, data),
    delete: (apiEndpoint) => axios.delete(apiEndpoint),
    download: (apiEndpoint, params) => axios.get(apiEndpoint, { params, responseType: 'blob' }),
}

export default apiService;
